export interface NavSearchItem {
  label: string;
  path: string;
  keywords: string[];
}

function tokenize(query: string): string[] {
  return query
    .toLowerCase()
    .trim()
    .split(/\s+/)
    .filter((w) => w.length >= 2);
}

export function scoreNavSearch(query: string, item: NavSearchItem): number {
  const q = query.toLowerCase().trim();
  if (!q) return 0;

  const label = item.label.toLowerCase();
  let score = 0;

  if (label === q) score += 200;
  else if (label.startsWith(q)) score += 120;
  else if (label.includes(q)) score += 80;

  const words = tokenize(q);
  for (const word of words) {
    for (const kw of item.keywords) {
      if (kw === word) score += 60;
      else if (kw.startsWith(word)) score += 35;
      else if (word.length >= 3 && kw.includes(word)) score += 15;
    }
    if (label.split(/\s+/).some((part) => part.startsWith(word))) score += 25;
  }

  return score;
}

export function searchNavigation(
  query: string,
  index: NavSearchItem[],
  limit = 8
): NavSearchItem[] {
  const q = query.trim();
  if (!q) return [];

  return index
    .map((item) => ({ item, score: scoreNavSearch(q, item) }))
    .filter(({ score }) => score > 0)
    .sort((a, b) => b.score - a.score)
    .slice(0, limit)
    .map(({ item }) => item);
}
